import { UserSearchFilters } from "../support/models/users/user-search-filters";
import { DealerSearchFilters } from "../support/models/dealers/dealer-search-filters";
import { BaseModuleState } from "./_BaseModuleState";

/**
 * The support module redux shape
 */
export class SupportModuleState extends BaseModuleState {

    public userSearchFilters : UserSearchFilters | undefined = undefined;

    public dealerSearchFilters : DealerSearchFilters | undefined = undefined;

}
